<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="reference-tables" color="white"></help-link>
                </v-toolbar>
            </v-card>
            <v-progress-linear v-if="loading" indeterminate height="3" style="margin-top:1px;"></v-progress-linear>

            <v-expansion-panel v-if="!loading" v-model="panel" expand style="margin-top:5px;">
                <!-- Income Tax Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">Income Tax Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_IcomeTaxTable"
                            :items="ref_tables.incomeTaxTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncTax"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.type }}</td>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.lowerLimit)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            <span v-if="props.item.upperLimit==-1">Over {{ numFormat.formatNumber(props.item.lowerLimit) }}</span>
                                            <span v-else>{{ numFormat.formatNumber(props.item.upperLimit) }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.taxOnLowerLimit)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.taxOnExcessOverLowerLimit * 100) }} %
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- SSS Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">SSS Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_SSS"
                            :items="ref_tables.sssTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncSSS"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rsS_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rsS_EE)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.eC_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.eC_EE)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.mpF_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.mpF_EE)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Pagibig Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">Pagibig Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_Pagibig"
                            :items="ref_tables.pagibigTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncPagibig"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.salaryEnd>1500" class="text-xs-right">
                                            Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.employeeShare*100)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.employerShare*100)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.maxAmount)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Philhealth Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">Philhealth Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_Philhealth"
                            :items="ref_tables.philHealthTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncPhilhealth"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.salaryEnd>100000" class="text-xs-right">
                                            Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.premiumRate" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.premiumRate*100)}} %
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.floorAmt" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.floorAmt)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.ceilingAmt" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.ceilingAmt)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Overtime Rates Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">Overtime Rates Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_Overtime"
                            :items="ref_tables.overtimeRatesTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncOT"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.description }}</td>
                                    <td>{{ props.item.workingHours }}</td>
                                    <td>{{ props.item.dayType }}</td>
                                    <td>{{ props.item.holidayType }}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rate)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.premiumOnlyRate)}} %
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Minimum Wage Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold">Minimum Wage Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="header_MinimumWage"
                            :items="ref_tables.minimumWage"
                            :loading="loading"
                             :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncMW"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.year }}</td>
                                    <td>{{ props.item.regionCode }}</td>
                                    <td>{{ props.item.sector }}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.fromAmount)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.toAmount)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-flex>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'ReferenceTables',
    metaInfo: {
        title: 'Reference Tables',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Reference Tables' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        return {
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            panel: [false],
            ref_tables: [],
            paginationSyncTax: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Tax`)},
            paginationSyncSSS: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-SSS`)},
            paginationSyncPagibig: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Pagibig`)},
            paginationSyncPhilhealth: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Philhealth`)},
            paginationSyncOT: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-OT`)},
            paginationSyncMW: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-MW`)},
            header_IcomeTaxTable: [
                {text:'Type', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Effective Date', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Lower Limit', align: 'right',value: '', width: '15%', sortable:false},
                {text:'Upper Limit', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Tax on Lower Limit', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Tax on Excess over Lower Limit', align:'right',value: '',  width: '15%', sortable:false},
            ],
            header_SSS: [
                {text:'Effective Date', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '10%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '10%', sortable:false},
                {text:'RSS_ER', align: 'right',value: '',  width: '10%', sortable:false},
                {text:'RSS_EE', align:'right',value: '',  width: '10%', sortable:false},
                {text:'EC_ER', align:'right',value: '',  width: '10%', sortable:false},
                {text:'EC_EE', align:'right',value: '',  width: '10%', sortable:false},
                {text:'WISP_ER', align:'right',value: '',  width: '10%', sortable:false},
                {text:'WISP_EE', align:'right',value: '',  width: '10%', sortable:false},
            ],
            header_Pagibig: [
                {text:'Effective Date', align: 'left',value: '', width: '15%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '15%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Employee Share', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Employer Share', align:'right',value: '',  width: '15%', sortable:false},
                {text:'Maximum Amt', align:'right',value: '',  width: '15%', sortable:false},
            ],
            header_Philhealth: [
                {text:'Effective Date', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '20%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '20%', sortable:false},
                {text:'Premium Rate', align: 'right',value: '',  width: '20%', sortable:false},
                {text:'Minimum Amount', align:'right',value: '',  width: '20%', sortable:false},
                {text:'Maximum Amount', align:'right',value: '',  width: '20%', sortable:false},
            ],
            header_Overtime: [
                {text:'Description', align: 'left',value: '', width: '40%', sortable:false},
                {text:'Working Hours', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Day Type', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Holiday Type', align: 'left',value: '', width: '30%', sortable:false},
                {text:'Base+Premium Rate', align:'right',value: '',  width: '10%', sortable:false},
                {text:'Premium Only Rate', align:'right',value: '',  width: '10%', sortable:false},
            ],
            header_MinimumWage: [
                {text:'Year', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Region', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Sector', align: 'left',value: '', width: '30%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '20%', sortable:false},
                {text:'Salary To', align:'right',value: '',  width: '20%', sortable:false},
            ],
        }
    },
    methods: {
        async getData() {
            try {
                this.loading = true
                const response = await payrollApi.getReferenceTables()
                if (response && response.status==200) {
                    this.ref_tables = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Reference Tables'
        })

        this.getData()
    },
    watch: {
        'paginationSyncTax.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Tax`, newVal);
        },
        'paginationSyncSSS.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-SSS`, newVal);
        },
        'paginationSyncPagibig.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Pagibig`, newVal);
        },
        'paginationSyncPhilhealth.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Philhealth`, newVal);
        },
        'paginationSyncOT.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-OT`, newVal);
        },
        'paginationSyncMW.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-MW.`, newVal);
        }
    },
}
</script>